// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_RY6","cls2":"SuggestionCard-cls2_1Kz SuggestionCard-cls1_RY6","small":"SuggestionCard-small_jTg"};